import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from "@angular/common/http";

/*
Interceptor to intercept requests intended from V2 to KAPS backend while maintaining
cookies/configuration required from V1
*/
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Domains where requested are intercepted
    const interceptedDomains = [
      "localhost",
      "syion.net",
      "komoco.com.sg",
      "kaps.local",
    ];

    if (
      interceptedDomains.some((domain) => req.url.includes(domain))
    ) {
      // Read the anti-forgery token from the XSRF-TOKEN cookie and echo it in the
      // X-XSRF-TOKEN header so the backend double-submit check accepts the request.
      // Attached on every method, not just writes, because the KAPS backend also
      // validates the token on authenticated GET reads to .asmx, so v2's reads need
      // it too. Only first-party (interceptedDomains) requests get the token, so it
      // is never sent to a third party. The cookie is host-only and shared across
      // ports on the same host, so the v2 dev port reads the token KAPS sets.
      const xsrfToken = this.readXsrfToken();

      // Clone the request and replace the original headers with
      // cloned headers, updated with the authorization.
      if (req.body instanceof FormData || req.responseType === "blob") {
        const FormDataReq = req.clone({
          headers: xsrfToken
            ? req.headers.set("X-XSRF-TOKEN", xsrfToken)
            : req.headers,
          withCredentials: true,
        });
        return next.handle(FormDataReq);
      } else {
        let headers = req.headers.set(
          "Content-Type",
          "application/json; charset=utf-8",
        );
        if (xsrfToken) {
          headers = headers.set("X-XSRF-TOKEN", xsrfToken);
        }
        const authReq = req.clone({
          headers,
          withCredentials: true,
        });
      // Send cloned request with header to the next handler.
        return next.handle(authReq);
      }
    }

    // If not match, return original request
    return next.handle(req);
  }

  // Return the raw XSRF-TOKEN cookie value, or null when the cookie is absent.
  // The value is sent as-is to match the token KAPS stores in the cookie.
  private readXsrfToken(): string | null {
    const match = document.cookie.match("(^|;)\\s*XSRF-TOKEN\\s*=\\s*([^;]+)");
    return match ? (match.pop() as string) : null;
  }
}
